var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import * as React from "react";
function defaultPromiseFunc() {
  return __async(this, null, function* () {
    return new Promise((resolve) => {
      resolve();
    });
  });
}
const defaultAuthContext = {
  isUserLoggedIn: () => Promise.resolve(false),
  getUser: () => {
    return {
      email: "",
      name: "",
      tid: "",
      oid: ""
    };
  },
  getTenantId: () => "common",
  logIn: defaultPromiseFunc,
  logInToTenantSilent: defaultPromiseFunc,
  logOut: defaultPromiseFunc,
  getToken: defaultPromiseFunc,
  getTokenExpiration: () => void 0
};
const AuthContextType = React.createContext(defaultAuthContext);
AuthContextType.displayName = "AuthContext";
export {
  AuthContextType,
  defaultAuthContext
};
//# sourceMappingURL=IAuthContext.js.map
